"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMainSections = exports.getSecondarySections = exports.getGeneralLinks = exports.getMinimalGeneralLinks = exports._getCAPrivacyNoticeLinks = exports.getLocales = exports.SALES_CONTACT_SUPPORTED_TLDS = exports.DEVELOPER_URL = void 0;

var _gettext = _interopRequireDefault(require("@eb/gettext"));

var _util = require("eventbrite_design_system/select/util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var DEVELOPER_URL = 'https://www.eventbrite.com/platform/';
exports.DEVELOPER_URL = DEVELOPER_URL;
var SALES_CONTACT_SUPPORTED_TLDS = {
  '.com': 1,
  '.co.uk': 1,
  '.com.au': 1,
  '.de': 1,
  '.ie': 1,
  '.com.ar': 1
};
exports.SALES_CONTACT_SUPPORTED_TLDS = SALES_CONTACT_SUPPORTED_TLDS;
var _HTTP_REGEX = /http:/;

var getLocales = function getLocales(locales) {
  return (0, _util.getSelectPropValues)(locales, 'locale_name', 'locale');
};

exports.getLocales = getLocales;

var _getSalesContactLinks = function _getSalesContactLinks(serverUrl, localeInfo) {
  var tld = localeInfo.tld,
      locale = localeInfo.locale;
  var supportsSalesContacts = tld in SALES_CONTACT_SUPPORTED_TLDS || tld === '.ca' && locale === 'en_CA';
  var links = [];

  if (supportsSalesContacts) {
    links = [{
      url: "".concat(serverUrl).concat(localeInfo['sales_contact_landing_page']),
      content: localeInfo['sales_contact_link_text'],
      additionalClassName: 'eds-hide-md eds-hide-mw eds-hide-ln eds-hide-lg eds-hide-lw'
    }];
  }

  return links;
};

var _getImpressumLinks = function _getImpressumLinks(impressumUrl, tld) {
  var links = [];

  if (tld === '.de') {
    links = [{
      url: impressumUrl,
      content: 'Impressum'
    }];
  }

  return links;
};

var _getCAPrivacyNoticeLinks = function _getCAPrivacyNoticeLinks(serverUrl, tld) {
  var links = [];

  if (tld === '.com') {
    links = [{
      url: "".concat(serverUrl, "/support/articles/en_US/Troubleshooting/supplemental-privacy-notice-for-california-residents?lg=en_US"),
      content: 'CA Privacy Notice'
    }];
  }

  return links;
};

exports._getCAPrivacyNoticeLinks = _getCAPrivacyNoticeLinks;

var getMinimalGeneralLinks = function getMinimalGeneralLinks(serverUrl) {
  return [{
    url: "".concat(serverUrl, "/l/LegalTerms/"),
    content: (0, _gettext.default)('Terms'),
    rel: 'nofollow'
  }, {
    url: "".concat(serverUrl, "/privacypolicy/"),
    content: (0, _gettext.default)('Privacy'),
    rel: 'nofollow'
  }, {
    url: "".concat(serverUrl, "/cookies/"),
    content: (0, _gettext.default)('Cookies'),
    rel: 'nofollow'
  }];
};

exports.getMinimalGeneralLinks = getMinimalGeneralLinks;

var getGeneralLinks = function getGeneralLinks(serverUrl, localeInfo, helpLinks) {
  return [{
    url: "".concat(serverUrl, "/how-it-works"),
    content: (0, _gettext.default)('How It Works'),
    additionalClassName: 'eds-hide-md eds-hide-mw eds-hide-ln eds-hide-lg eds-hide-lw'
  }, {
    url: "".concat(serverUrl, "/fees"),
    content: (0, _gettext.default)('Pricing'),
    additionalClassName: 'eds-hide-md eds-hide-mw eds-hide-ln eds-hide-lg eds-hide-lw'
  }, {
    url: "".concat(localeInfo['contact_us_url']),
    content: (0, _gettext.default)('Contact Support'),
    additionalClassName: 'eds-hide-md eds-hide-mw eds-hide-ln eds-hide-lg eds-hide-lw'
  }].concat(_toConsumableArray(_getSalesContactLinks(serverUrl, localeInfo)), [{
    url: "".concat(serverUrl, "/about"),
    content: (0, _gettext.default)('About')
  }, {
    url: "https://".concat(localeInfo['blog_url']),
    content: (0, _gettext.default)('Blog')
  }, {
    url: helpLinks.home,
    content: (0, _gettext.default)('Help')
  }, {
    url: "".concat(serverUrl, "/careers/"),
    content: (0, _gettext.default)('Careers')
  }, {
    url: "".concat(serverUrl).concat(localeInfo['press_blog_url']),
    content: (0, _gettext.default)('Press')
  }, {
    url: 'https://investor.eventbrite.com',
    content: (0, _gettext.default)('Investors')
  }, {
    url: "".concat(serverUrl, "/security/"),
    content: (0, _gettext.default)('Security'),
    rel: 'nofollow'
  }, {
    url: DEVELOPER_URL,
    content: (0, _gettext.default)('Developers')
  }, {
    url: "".concat(serverUrl, "/l/LegalTerms/"),
    content: (0, _gettext.default)('Terms'),
    rel: 'nofollow'
  }, {
    url: "".concat(serverUrl, "/privacypolicy/"),
    content: (0, _gettext.default)('Privacy'),
    rel: 'nofollow'
  }], _toConsumableArray(_getCAPrivacyNoticeLinks(serverUrl, localeInfo.tld)), [{
    url: "".concat(serverUrl, "/cookies/"),
    content: (0, _gettext.default)('Cookies'),
    rel: 'nofollow'
  }], _toConsumableArray(_getImpressumLinks(helpLinks.impressum, localeInfo.tld)));
};

exports.getGeneralLinks = getGeneralLinks;

var getSecondarySections = function getSecondarySections(isUserAuthenticated, countries) {
  var secondarySections;

  if (isUserAuthenticated) {
    secondarySections = [{
      title: (0, _gettext.default)('Country'),
      links: countries.map(function (_ref) {
        var href = _ref.href,
            locale = _ref.locale,
            content = _ref.locale_name;
        var url = href.replace(_HTTP_REGEX, 'https:');
        return {
          url: url,
          content: content,
          'data-automation': "footer-".concat(locale)
        };
      })
    }];
  }

  return secondarySections;
};

exports.getSecondarySections = getSecondarySections;

var _getMainLinks = function _getMainLinks(links) {
  return links.map(function (_ref2) {
    var link = _ref2.link,
        title = _ref2.title;
    return {
      url: link,
      content: title
    };
  });
};

var _getSocialLinks = function _getSocialLinks(serverUrl, localeInfo) {
  return [{
    url: "".concat(localeInfo['contact_us_url']),
    content: (0, _gettext.default)('Contact Support')
  }].concat(_toConsumableArray(_getSalesContactLinks(serverUrl, localeInfo)), [{
    url: "https://".concat(localeInfo['twitter_page']),
    content: (0, _gettext.default)('Twitter'),
    target: '_blank',
    rel: 'noopener noreferrer'
  }, {
    url: "https://".concat(localeInfo['facebook_page']),
    content: (0, _gettext.default)('Facebook'),
    target: '_blank',
    rel: 'noopener noreferrer'
  }, {
    url: "https://".concat(localeInfo['linked_in_page']),
    content: (0, _gettext.default)('LinkedIn'),
    target: '_blank',
    rel: 'noopener noreferrer'
  }, {
    url: "https://".concat(localeInfo['instagram_page']),
    content: (0, _gettext.default)('Instagram'),
    target: '_blank',
    rel: 'noopener noreferrer'
  }]);
};

var getMainSections = function getMainSections(serverUrl, localeInfo, popularSearches, eventsToPlan, thirdFooterColumn, thirdFooterColumnName) {
  return [{
    title: (0, _gettext.default)('Use Eventbrite'),
    links: _getMainLinks(popularSearches)
  }, {
    title: (0, _gettext.default)('Plan Events'),
    links: _getMainLinks(eventsToPlan)
  }, {
    title: thirdFooterColumnName,
    links: _getMainLinks(thirdFooterColumn)
  }, {
    title: (0, _gettext.default)('Connect With Us'),
    links: _getSocialLinks(serverUrl, localeInfo)
  }];
};

exports.getMainSections = getMainSections;
//# sourceMappingURL=utils.js.map